"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M9.83 12H11v6h2v-6h1.17L12 9.83z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M5 4h14v2H5zm7 3-7 7h4v6h6v-6h4zm1 5v6h-2v-6H9.83L12 9.83 14.17 12z"
}, "1")], 'PublishTwoTone');